import clsx from "clsx";
import { CSSProperties } from "react";

import styles from "./SvgIcon.module.css";
import { SvgIconProps } from "./types";

export const classes = {
    stroke: "colorStroke",
    fill: "colorFill",
};

const DEFAULT_BG_COLOR = "transparent";

const SvgIcon = ({
    size = 24,
    className,
    style,
    viewBox = "0 0 24 24",
    fill = "none",
    xmlns = "http://www.w3.org/2000/svg",
    "aria-hidden": ariaHidden = true,
    focusable = "false",
    ...props
}: SvgIconProps) => {
    // Calculate dynamic styles and classes based on size
    const getSizeConfig = (): { className: string; style?: CSSProperties } => {
        if (size === "auto") {
            return { className: styles.sizeAuto };
        }

        if (size >= 24) {
            return {
                className: styles.sizeLarge,
                style: {
                    border: `calc((${size}px - 24px) / 2) solid var(--icon-bg-color, ${DEFAULT_BG_COLOR})`,
                },
            };
        }

        return {
            className: styles.sizeSmall,
            style: {
                border: `calc((${size}px - 12px) / 2) solid var(--icon-bg-color, ${DEFAULT_BG_COLOR})`,
            },
        };
    };

    const sizeConfig = getSizeConfig();

    return (
        <svg
            viewBox={viewBox}
            fill={fill}
            xmlns={xmlns}
            aria-hidden={ariaHidden}
            focusable={focusable}
            className={clsx("svg-icon", styles.svgIcon, sizeConfig.className, className)}
            style={{
                ...sizeConfig.style,
                ...style,
            }}
            {...props}
        />
    );
};

export default SvgIcon;
